import React, { PropsWithChildren } from "react";

type DownloadPdfProgressState = "idle" | "inProgress" | "complete";

export interface ReaderContextI {
  isEnglish: boolean;
  setIsEnglish: (isEnglish: boolean) => void;
  documentHeight: number;
  setDocumentHeight: (height: number) => void;
  tocIsOpen: boolean;
  setTocIsOpen: (isOpen: boolean) => void;
  activeSectionId: string | null;
  setActiveSectionId: (sectionId: string) => void;
  downloadModalIsOpen: boolean;
  setDownloadModalIsOpen: (isOpen: boolean) => void;
  downloadPdfProgress: DownloadPdfProgressState;
  setDownloadPdfProgress: (state: DownloadPdfProgressState) => void;
}

export const ReaderContext = React.createContext<ReaderContextI>({
  // App language
  isEnglish: false,
  setIsEnglish: () => {
    /* do nothing */
  },
  documentHeight: 0,
  setDocumentHeight: () => {
    /* do nothing */
  },
  // Handler for opening and closing table of contents (TOC)
  tocIsOpen: false,
  setTocIsOpen: () => {
    /* do nothing */
  },
  // Handlers for setting active section in TOC
  activeSectionId: null,
  setActiveSectionId: () => {
    /* do nothing */
  },
  // Handlers for download modal and download state
  downloadModalIsOpen: false,
  setDownloadModalIsOpen: () => {
    /* do nothing */
  },
  downloadPdfProgress: "idle",
  setDownloadPdfProgress: () => {
    /* do nothing */
  },
} as ReaderContextI);

export const ReaderContextProvider = ({ children }: PropsWithChildren) => {
  const [isEnglish, setIsEnglish] = React.useState(false);
  const [documentHeight, setDocumentHeight] = React.useState(0);
  const [tocIsOpen, setTocIsOpen] = React.useState(false);
  const [activeSectionId, activeSectionIdSetter] = React.useState<
    string | null
  >(null);
  const [downloadModalIsOpen, setDownloadModalIsOpen] = React.useState(false);
  const [downloadPdfProgress, setDownloadPdfProgress] =
    React.useState<DownloadPdfProgressState>("idle");

  const setActiveSectionId = (sectionId: string) =>
    activeSectionIdSetter(sectionId);

  return (
    <ReaderContext.Provider
      value={{
        isEnglish,
        setIsEnglish,
        documentHeight,
        setDocumentHeight,
        tocIsOpen,
        setTocIsOpen,
        activeSectionId,
        setActiveSectionId,
        downloadModalIsOpen,
        setDownloadModalIsOpen,
        downloadPdfProgress,
        setDownloadPdfProgress,
      }}
    >
      {children}
    </ReaderContext.Provider>
  );
};
